module.exports = __webpack_public_path__ + "images/sprites/ui/review_title_0e92c1427378983ad3414a273b48907f.png";